<div class="support-content">
  <div class="row">
    <div class="col-12">
      <ul class="nav nav-tabs detailed-tabs relative page-sub-heading" role="tablist">
        <li class="nav-item active">
          <a class="nav-link text-center mt-1 active ml-4" role="tab" data-toggle="tab" href="#search" (click)="loadSearch()">
            <i class="fa fa-search"></i> Account Search
          </a>
        </li>
</ul>
</div>
</div>

<div class="row">
  <div class="col-12">
    <div role="tabpanel" class="tab-pane fade in active show relative" id="search">
      @if (searchTab) {
        <app-advanced-search></app-advanced-search>
      }
    </div>
</div>
</div>
</div>


